import type { Row } from '../../hooks/useTable/types.js';

/**
 * Checks if a row is disabled.
 * @param cacheMap - save lazily to this map
 * @param row - row to check
 * @param isDisabledCallback - optionally for getting notified when isDisabled is called (for example, used to test performance)
 * @returns
 */
export function isRowDisabled<TData>(
  cacheMap: Map<string, boolean>,
  row: Row<TData> | undefined,
  isDisabledCallback?: (row: Row<TData> | undefined) => void,
): boolean {
  if (isDisabledCallback) {
    isDisabledCallback(row);
  }
  if (row === undefined) {
    return false;
  }

  let result = false;
  if (row.getCanExpandDisabled()) {
    result = true;
  } else {
    const parent = row.getParentRow();
    if (parent === undefined) {
      result = false;
    } else {
      const cachedResult = cacheMap.get(parent.id);
      if (cachedResult !== undefined) {
        result = cachedResult;
      } else {
        result = isRowDisabled(cacheMap, parent, isDisabledCallback);
      }
    }
  }

  cacheMap.set(row.id, result);

  return result;
}
